export const BINARY_ANSWERS = ['YES', 'NO'] as const;

export type BinaryAnswer = (typeof BINARY_ANSWERS)[number];

export const NONE_VALUE = 'NONE' as const;
export const NONE_ANSWER = [NONE_VALUE] as const;

export type NoneAnswer = typeof NONE_ANSWER;

export const NOT_APPLICABLE_VALUE = 'N/A' as const;
